import { faEdit, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useEffect, useState } from "react";
import { Helmet } from 'react-helmet-async';
import { useSelector } from "react-redux";
import Layout from "../../../components/global/Layout/Layout";

// Sweetalert
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { removeHTMLTags } from "../../../utils/helper";
import Sidebar from "../../../components/Settings/Sidebar/Sidebar";
import DropdownMenu from "../../../components/Settings/DropdownMenu/DropdownMenu";
import { userToken } from "../../../utils/config";

const Settings = () => {
    const MySwal = withReactContent(Swal);

    const { myUser } = useSelector((state) => state.user);

    const [loading, setLoading] = useState(false);


    const [inputState, setInputState] = useState({
        email: '',
        username: ''
    });

    const [edit, setEdit] = useState(false);

    useEffect(() => {
        // Check user state readiness
        if (myUser) {
            setInputState({
                // General Settings
                email: myUser?.email,
                username: myUser?.username,
            });
        };
    }, [myUser]);

    // Handle input changes
    const handleChange = (e) => {
        const value = e.target.value;
        setInputState({
            ...inputState,
            [e.target.name]: value
        });
    };

    // Update General Setting
    const handleGeneralSettingUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);

        let response = await axios({
            method: "post",
            url: `${process.env.REACT_APP_BASE_URL}/api/user/profile/updateAccount`,
            headers: {
                "Content-Type": "application/json",
                Authorization: userToken
            },
            data: {
                'username': inputState.username,
                'email': inputState.email
            },
        });

        if (response.data.status === "success") {
            setLoading(false);
            // Alert Success
            await MySwal.fire({
                title: <strong>Success!</strong>,
                text: removeHTMLTags(response.data.message) + '. You will be redirected to Login page',
                icon: 'success',
                confirmButtonText: 'Close'
            });
            // navigate('https://www.codepolitan.com/logout', { replace: true })
            window.location.href = `${process.env.REACT_APP_URL}/logout`;
        } else {
            setLoading(false);
            // Alert Filed
            await MySwal.fire({
                title: <strong>Oops!</strong>,
                text: removeHTMLTags(response.data.message),
                icon: 'error',
                confirmButtonText: 'Close'
            });
            console.log(response.data);
        };
    };

    return (
        <>
            <Helmet>
                <title>Akun</title>
            </Helmet>
            <Layout>
                <section className="section mt-5">
                    <div className="container-fluid">
                        <div className="row my-5">
                            <div className="col-lg-2 d-none d-lg-block">
                                <Sidebar />
                            </div>
                            <div className="col-lg-10">
                                <div className="d-lg-none mb-3">
                                    <DropdownMenu />
                                </div>
                                <div className="bg-white p-3">
                                    <div className="card border-0 mb-3">
                                        <div className="card-header border-0">
                                            <div className="d-flex justify-content-between">
                                                <h5 className="text-muted my-2">Pengaturan Akun</h5>
                                                <button onClick={() => setEdit(!edit)} className="btn text-muted shadow-none my-auto">
                                                    <FontAwesomeIcon icon={!edit ? faEdit : faTimes} />
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            {edit ? (
                                                <form onSubmit={handleGeneralSettingUpdate}>
                                                    <div className="mb-3">
                                                        <label htmlFor="username" className="form-label">Username</label>
                                                        <input name="username" onChange={handleChange} value={inputState.username.replace(/[^a-zA-Z0-9 ]/g, "").trim()} type="text" className="form-control" id="username" placeholder="Username" required />
                                                        <small className="text-muted"><i>Tidak boleh menggunakan spasi dan simbol, atau menggunakan nama yang terlalu panjang. Setelah mengganti username Anda harus login kembali.</i></small>
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="email" className="form-label">Email</label>
                                                        <input name="email" onChange={handleChange} value={inputState.email} type="email" className="form-control" id="email" placeholder="name@example.com" readOnly />
                                                    </div>
                                                    <div className="d-flex justify-content-end mb-3">
                                                        <button className="btn btn-primary" type="submit" disabled={loading}>Update</button>
                                                    </div>
                                                </form>
                                            ) : (
                                                <>
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <p className="m-0">Username</p>
                                                        </div>
                                                        <div className="col">
                                                            <p className="fw-bolder m-0">{myUser?.username}</p>
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <p className="m-0">Email</p>
                                                        </div>
                                                        <div className="col">
                                                            <p className="fw-bolder m-0">{myUser?.email}</p>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout >
        </>
    );
};

export default Settings;
